import styled from 'styled-components';

export const TreeSelectStyled = styled.div`
  width: 240px;
  .ant-select-selector {
    box-shadow: none !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
  }
  .ant-select-multiple .ant-select-selector {
    padding: 0;
  }
  .ant-select-multiple .ant-select-selector::after {
    width: 240px;
    height: 0;
    margin: 0;
    border-bottom: 1px solid #949494;
  }
  .ant-select-multiple .ant-select-selection-overflow:focus-visible {
    border: none;
  }
  .ant-select-multiple .ant-select-selection-item {
    border: none;
    background: none;
  }
  .ant-select-multiple .ant-select-selection-item-content {
    color: #1565c0;
  }
  .triangle {
    width: 24px;
    height: 24px;
    position: relative;
    top: -46.5%;
    left: 220px;
    overflow: hidden;
  }
  .arrow_down {
    transform: rotate(-90deg);
  }
  .arrow_up {
    transform: rotate(90deg);
  }
`;
